<template>
  <div class="dft-container" :style="[container_Style]">
    <div class="modetype_box">
      <div class="dft-header_box" v-if="show_class_title" :style="[header_box_style]">
        <div class="dft-header_title1">{{ activityTitleData&&activityTitleData.activityTitle }}</div>
        <div class="dft-header_right" v-show="showMoreBtn">查看更多></div>
      </div>
      <div class="dft-list" :style="[list_Style]">
        <div :ref="'dftItem'+index" class="dft-item" v-for="(item,index) in (grouponWeappListDataList[0].length>0?grouponWeappListDataList[0]:dftList)" :key="index" :style="[list_item_Style(index)]">
          <div class="dft-goods_img" :style="[goods_img_Style]">
            <el-image class="img_class" :style="[image_Style]" :src="item.logo" :fit="fit"></el-image>
          </div>
          <div class="dft-goods_description" :style="[goods_description_Style]">
            <div class="ellipsis-text dft-goods_name" v-if="goodsName" :style="[{'margin-top': '6px'},goods_name_Style(index)]">{{ item.title }}</div>
            <div class="ellipsis-text dft-goods_info" v-if="show_goods_info" :style="[goods_info_Style]">{{ item.detail }}</div>
            <div style="margin-top: 6px;">
              <div class="flex center" v-if="marketLabel">
                <div class="tt" v-for="(ele,eindex) in item.lebel" :key="eindex">
                  {{ele}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    compData: {
        type: [Array,Object],
        default: ()=>[]
    },
  },
  options: {
    styleIsolation: 'shared', // 解除样式隔离
  },
  data () {
    return {
      showDialog: false,
      dftList: [],
      cd999: '9',
      curtab: {
        categoryList:[]
      },
      curtabIndex: 0,
      tagIndex: -1,
      queryInfo: {
        condition: {
        },
        currPage: 1,
        pageSize: 100
      },
      grouponWeappListData:[],
      grouponWeappListDataList: [[],[]],
      // unicOneGInfo: [],
    };
  },
  watch:{
    compData: {
      handler: function(newVal){
        if(newVal){
          this.$nextTick(() => {
            this.curtab = newVal?.attr?.['a0']?.groupList?.[0]
            console.log('marketzone---0',newVal,this.activityTitleData,'|-0',this.curtab)
            if(!this.curtab) return
            this.goodsList(this.curtab,0)
          });
        }
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    //数据
    groupList() {
      return this.compData?.attr?.['a0']?.groupList.length>0?this.compData?.attr?.['a0']?.groupList:[]
    },
    // 分类标题数据
    activityTitleData() {
      return this.compData?.attr?.['a0']?.groupList[0]
    },
    // 分类标题数据list
    activityTitleDataList() {
      return this.compData?.attr?.['a0']?.groupList
    },
    // 分类标题数量 0，1，2
    activityNum() {
      return this.compData?.attr?.['a0']?.groupList.length
    },
    //数据
    goodsList() {
      return async (curtab,index)=>{
        // const _index = this.groupList.findIndex(item=>item.groupId == this.curtab.groupId)
        const _SeckillListData = await this.getgoods(curtab,index)
        // this.curtabIndex = _index
        this.grouponWeappListData = _SeckillListData
        this.$set(this.grouponWeappListDataList,index,_SeckillListData)
        // this.grouponWeappListDataList[index] = _SeckillListData
        return _SeckillListData
      }
    },
    listClass() {
      return this.compData?.attr?.['a1']?.value
    },
    goodsClass() {
      return this.compData?.attr?.['a2']?.value
    },
    // 类型背景色
    bgcolor() {
      return this.compData?.attr?.['a2p']?.value
    },
    // 显示与否
    goodsName() {
      return this.compData?.attr?.['a10']?.value == '1'
    },
    //是否显示 标题
    show_class_title() {
      return this.compData?.attr?.['a1t']?.value == '1'
    },
    //是否显示描述
    show_goods_info() {
      return this.compData?.attr?.['a11']?.value == '1'
    },
    //是否显示市集标签
    marketLabel() {
      return this.compData?.attr?.['a12']?.value == '1'
    },
    //是否显示 更多按钮
    showMoreBtn() {
      return this.compData?.attr?.['a22']?.value == '1'
    },
    // 样式
    container_Style() {
      return {
        [this.compData?.attr?.['a2']?.key]: this.compData?.attr?.['a2']?.value,
        [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value,
        [this.compData?.attr?.['a8']?.key]: `${this.compData?.attr?.['a8']?.value}px`,
        'background-color': this.goodsClass=='1'||this.goodsClass=='3'?this.bgcolor:'transparent',
      }
    },
    header_box_style() {
      return {
        'width': `calc(100% - ${this.compData?.attr?.['a8']?.value}px)`,
        'margin-left': `${this.compData?.attr?.['a8']?.value / 2}px`,
        'margin-right': `${this.compData?.attr?.['a8']?.value / 2}px`,
				'background-color': this.goodsClass == '1' || this.goodsClass == '3' ? this.bgcolor : 'transparent',
      }
    },
    // main首推样式-----------
    top_list_Style(){
      return {
        'flex-direction': 'column',
        'margin-top': '8px',
        'margin-bottom': '2px',
        'padding': `0`,
        'margin-left': `${this.compData?.attr?.['a8']?.value / 2}px`,
        'margin-right': `${this.compData?.attr?.['a8']?.value / 2}px`,
        'padding-top': this.goodsClass=='1'?'0':'0' ,
        'padding-bottom': this.goodsClass=='1'?'6px':'0' ,
        'background-color': '#ffffff',//this.goodsClass=='4'?'transparent':'#ffffff',
      }
    },
    top_list_item_Style(){
      return {
        'display': 'flex',
        'background-color': '#ffffff',
        'margin': `${this.compData?.attr?.['a9']?.value / 2}px`,
        'box-shadow': this.goodsClass=='2'?'0 2px 12px rgba(100, 101, 102, .12)':'unset',
        'border': this.goodsClass=='3'?'1px solid #ebedf0':'none',
      }
    },
    top_goods_img_Style() {
      return {
        'width': '138px',
        'height': '138px',
        'margin': this.goodsClass=='2'?'8px 0 8px 8px':'0',
        'margin-right': '8px',
        'flex-shrink': '0',
        [this.compData?.attr?.['a3']?.key]: this.compData?.attr?.['a3']?.value,
      }
    },
    top_goods_description_Style(){
      return {
        'flex': '1',
        'padding': this.goodsClass=='2'||this.goodsClass=='3'?'8px 8px 8px 0':'0',
      }
    },
    top_goods_name_Style(){
      return {
        'max-height': '40px',
        '-webkit-line-clamp': '2',
        [this.compData?.attr?.['a6']?.key]: this.compData?.attr?.['a6']?.value,
        [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value,
      }
    },
    top_goods_price_Style(){
      return {
        'font-size': '18px',
        'line-height': '18px',
        [this.compData?.attr?.['a6']?.key]: this.compData?.attr?.['a6']?.value,
        [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value,
        'overflow': 'visible',
      }
    },
    // main首推样式-----------

    list_Style() {//列表
      switch (this.listClass) {
        case 0:
          return {
            'flex-direction': 'column',
            'padding': `0`,
            'margin-left': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'margin-right': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'padding-top': this.goodsClass=='1'?'0':'0' ,
            'padding-bottom': this.goodsClass=='1'?'10px':'0' ,
            'background-color': this.goodsClass=='4'?'transparent':'#ffffff',
            [this.compData?.attr?.['a3b']?.key]: this.compData?.attr?.['a3b']?.value,
          }
        case 1:
          return this.goodsClass == 5 ? {
            'display': 'grid',
            'grid-auto-rows': '5px',
            'grid-template-columns': 'repeat(auto-fill, calc(50% - 0))',
            'align-items': 'start',
            'justify-content': 'space-between',
            'padding': `0`,
            'margin-left': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'margin-right': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'background-color': this.goodsClass=='4'?'transparent':'#ffffff',
            [this.compData?.attr?.['a3b']?.key]: this.compData?.attr?.['a3b']?.value,
          } : {
            'display': 'grid',
            'grid-template-columns': 'repeat(2, 1fr)',
            'padding': `0`,
            'margin-left': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'margin-right': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'background-color': this.goodsClass=='4'?'transparent':'#ffffff',
            [this.compData?.attr?.['a3b']?.key]: this.compData?.attr?.['a3b']?.value,
          }
        case 2:
          return {
            'flex-wrap': 'wrap',
            'padding': `0`,
            'margin-left': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'margin-right': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'background-color': this.goodsClass=='4'?'transparent':'#ffffff',
            [this.compData?.attr?.['a3b']?.key]: this.compData?.attr?.['a3b']?.value,
          }
        case 3:
          return {
            'flex-direction': 'column',
            'padding': `0`,
            'margin-left': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'margin-right': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'background-color': this.goodsClass=='4'?'transparent':'#ffffff',
            [this.compData?.attr?.['a3b']?.key]: this.compData?.attr?.['a3b']?.value,
          }
        case 4:
          return {
            'flex-wrap': 'nowrap',
            'overflow-x': 'auto',
            'padding': `0`,
            'margin-left': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'margin-right': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'background-color': this.goodsClass=='4'?'transparent':'#ffffff',
            [this.compData?.attr?.['a3b']?.key]: this.compData?.attr?.['a3b']?.value,
          }
        case 5:
          return {
            'display': 'grid',
            'grid-template-columns': 'repeat(2, 1fr)',
            'padding': `0`,
            'margin-left': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'margin-right': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'background-color': this.goodsClass=='4'?'transparent':'#ffffff',
            [this.compData?.attr?.['a3b']?.key]: this.compData?.attr?.['a3b']?.value,
          }
        default:
          return {
          }
      }
    },
    list_item_Style() {//每一项
      return index => {
        switch (this.listClass) {
          case 0:
            return {
              // 'width': '100%',
              'display': 'flex',
              'background-color': '#ffffff',
              'margin': `${this.compData?.attr?.['a9']?.value / 2}px`,
              'box-shadow': this.goodsClass=='2'?'0 2px 12px rgba(100, 101, 102, .12)':'unset',
              'border': this.goodsClass=='3'?'1px solid #ebedf0':'none',
            }
          case 1:
            return this.goodsClass == 5 ? this.getLitemStyle(index) : {
              'margin': `${this.compData?.attr?.['a9']?.value / 2}px`,
              'box-shadow': this.goodsClass=='2'?'0 2px 12px rgba(100, 101, 102, .12)':'unset',
              'border': this.goodsClass=='3'?'1px solid #ebedf0':'none',
            }
          case 2:
            return {
              'width': this.activityNum == 1?`calc((100% / 3) - ${this.compData?.attr?.['a9']?.value}px)`:`calc((100% / 2) - ${this.compData?.attr?.['a9']?.value}px)`,
              'margin': `${this.compData?.attr?.['a9']?.value / 2}px`,
              'box-shadow': this.goodsClass=='2'?'0 2px 12px rgba(100, 101, 102, .12)':'unset',
              'border': this.goodsClass=='3'?'1px solid #ebedf0':'none',
            }
          case 3:
            return {
              'width': `calc(100% - ${this.compData?.attr?.['a9']?.value}px)`,
              'margin': `${this.compData?.attr?.['a9']?.value / 2}px`,
              'box-shadow': this.goodsClass=='2'?'0 2px 12px rgba(100, 101, 102, .12)':'unset',
              'border': this.goodsClass=='3'?'1px solid #ebedf0':'none',
            }
          case 4:
            return {
              'width': `calc(34% - ${this.compData?.attr?.['a9']?.value}px)`,
              'flex-shrink': '0',
              'margin': `${this.compData?.attr?.['a9']?.value / 2}px`,
              'box-shadow': this.goodsClass=='2'?'0 2px 12px rgba(100, 101, 102, .12)':'unset',
              'border': this.goodsClass=='3'?'1px solid #ebedf0':'none',
            }
          case 5:
            return index%3 == 0?{
              'grid-column': '1 / 3',
              'margin': `${this.compData?.attr?.['a9']?.value / 2}px`,
              'box-shadow': this.goodsClass=='2'?'0 2px 12px rgba(100, 101, 102, .12)':'unset',
              'border': this.goodsClass=='3'?'1px solid #ebedf0':'none',
            }:{}
          default:
            return {
            }
        }
      }
      
    },
    //--商品图
    goods_img_Style() {
      switch (this.listClass) {
        case 0:
          return {
            'width': '138px',
            'height': '138px',
            'margin': this.goodsClass=='2'?'8px 0 8px 8px':'0',
            'margin-right': '8px',
            'flex-shrink': '0',
            [this.compData?.attr?.['a3']?.key]: this.compData?.attr?.['a3']?.value,
          }
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          return {
            'width': '100%',
            [this.compData?.attr?.['a3']?.key]: this.compData?.attr?.['a3']?.value,
            [this.compData?.attr?.['a4']?.key]: this.compData?.attr?.['a4']?.value,
          }
        default:
          return {
          }
      }
    },
    image_Style() {
      return {
      }
    },
    fit() {
      return this.compData?.attr?.['a5']?.value
    },
    goods_description_Style() {//商品信息
      switch (this.listClass) {
        case 0:
          return {
            'flex': '1',
            'padding': this.goodsClass=='2'||this.goodsClass=='3'?'8px 4px 4px 0':'0',
          }
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          return {
            'padding': '0 4px 10px',
          }
        default:
          return {
          }
      }
    },
    goods_name_Style() {//商品名
      return index => {
        switch (this.listClass) {
          case 0:
            return {
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData?.attr?.['a6']?.key]: this.compData?.attr?.['a6']?.value,
              [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value,
            }
          case 1:
          case 2:
          case 4:
            return {
              'font-size': '12px',
              'margin-top': '8px',
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData?.attr?.['a6']?.key]: this.compData?.attr?.['a6']?.value,
              [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value,
            }
          case 3:
            return {
              'margin-top': '8px',
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData?.attr?.['a6']?.key]: this.compData?.attr?.['a6']?.value,
              [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value,
            }
          case 5:
            return index%3 == 0?{
              'margin-top': '8px',
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData?.attr?.['a6']?.key]: this.compData?.attr?.['a6']?.value,
              [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value,
            }:{
              'font-size': '12px',
              'margin-top': '8px',
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData?.attr?.['a6']?.key]: this.compData?.attr?.['a6']?.value,
              [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value,
            }
          default:
            return {
            }
        }
      }
    },
    goods_info_Style() {//商品描述
      return {
        'max-height': '32px',
      }
    },
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
      // console.log('-----2')
    })
  },

  methods: {
    initData(){
    },
    handleFinish(item){},
    // 获取商品
    getgoods(groupList_item,index){
      const that = this
      return new Promise(async (resolve,reject)=>{
        console.log('??>>>>',groupList_item.activityCode,groupList_item,index)
        if(!groupList_item){
          resolve([])
          return
        }
        const _data = {
          condition: {
            activityType: groupList_item.activityCode,
          },
          currPage: 1,
          pageSize: 8
        }
        await this.$http.post("/supplierActivity/list", _data).then(response=> {
          if (response.data.code == 200) {
            resolve(response.data.data.data.map(item=>{
              return {
                ...item,
                lebel: item.label.split(',').filter(ite=>ite != ''),//['限时优惠','爆款特惠','口感香甜']
              }
            }))
          }else{
            resolve([])
          }
        }).catch(err=>{
          resolve([])
        })
      })
    },
    getLitemStyle(index){
      this.$nextTick(() => {
        const el = this.$refs['dftItem'+index][0]
        const rows = Math.ceil(el.clientHeight / 5) + 0
        // console.log('>J?',index,el,rows)
        el.style.gridRowEnd = `span ${rows}`
        el.style.margin= `${this.compData?.attr?.['a9']?.value / 2}px`
        // el.style = {'grid-row-end': `span ${rows}`}
        // return {'grid-row-end': 'span ' + rows}
      })
    },
  },
};
</script>

<style lang="scss" scoped>
// @import url(../storecommon.scss);
.dft-container{
    width: 100%;
    box-sizing: border-box;
  }
  .modetype_box{
    width: 100%;
    height: auto;
  }
  .modetype_item{
    width: 100%;
  }
  .dft-header_box{
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
  }
  .dft-header_title{
    font-size: 20px;
    font-weight: 700;
    position: relative;
    line-height: 32px;
    padding-left: 12px;
    transform: translateY(2px);
    z-index: 2;
    &::before{
      position: absolute;
      bottom: 2px;
      left: 24px;
      content: '';
      width: 60px;
      height: 7px;
      border-radius: 3px;
      background: #fc9105;
      z-index: -1;
    }
  }
  .dft-header_title2{
    font-size: 20px;
    font-weight: 700;
    position: relative;
    line-height: 32px;
    padding-left: 12px;
    transform: translateY(2px);
    z-index: 2;
  }
  .dft-header_right{
    font-size: 15px;
    color: #777;
  }
  .eltabs{
    margin: 0 4px;
    /deep/.el-tabs__header{
      margin-bottom: 0;
    }
  }
  .dft-list{
    display: flex;
    overflow: hidden;
    .dft-item{
      box-sizing: border-box;
      .dft-goods_img{
        position: relative;
        max-height: 500px;
        overflow: hidden;
        .countdown_area{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          box-sizing: border-box;
          height: auto;
          max-height: 40px;
          padding: 0 6px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: linear-gradient(to right, #F86F30, #E91717);
          color: #fff;
          .countdown_title{
            font-weight: 700;
            font-size: 20px;
          }
          .countdown_cnt{
            display: flex;
            .countdown_info{
              height: 20px;
              line-height: 20px;
              font-size: 12px;
              opacity: .8;
            }
            .countdown_time{
              height: 20px;
              line-height: 20px;
              font-size: 12px;
              /deep/p{
                margin: 0;
              }
            }
          }
        }
        .grouponNum{
          position: absolute;
          left: 0px;
          bottom: 20px;
          background: #333;
          color: #fff;
          height: 18px;
          line-height: 16px;
          font-size: 11px;
          text-align: center;
          box-sizing: border-box;
          padding: 1px 5px;
          margin: 4px 8px;
        }
      }
      .dft-goods_description{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .dft-goods_name{
          word-break: break-all;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          line-height: 20px;
          font-size: 14px;
        }
        .dft-goods_info{
          color: #969799;
          font-size: 12px;
          line-height: 16px;
          word-break: break-all;
          margin-top: 4px;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          box-sizing: border-box;
          justify-content: space-between;
          align-items: center;
          position: relative;
          .dft-goods_info1{
            font-size: 10px;
            margin-top: 0;
          }
          .dft-goods_info2{
            font-size: 10px;
            margin-top: 0;
          }
          
        }
        .dft-press_area{
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
          margin: 0;
          flex: 1;
          position: relative;
          .dft-goods_price{
            flex: 1;
            height: 18px;
            color: #f44;
            word-break: break-all;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            display: flex;
            align-items: flex-end;
            position: relative;
            .price-tag{
              margin-right: 2px;
              font-size: 12px;
              line-height: 14px;
            }
            .price-sale-price{
              font-family: Avenir;
            }
            .price-origin-price{
              margin-left: 1px;
              font-size: 11px;
              line-height: 14px;
              color: #c8c9cc;
              text-decoration: line-through;
            }
            .unic_price-origin-price{
              position: absolute;
              left: 0;
              top: -15px;
            }
          }
          .dft-goods_btn{
            flex-shrink: 0;
            height: 20px;
            margin-left: 1px;
            display: flex;
            align-items: flex-end;
            .btn-icon{
              line-height: 18px;
              color: #f44;
            }
            .dft-goods_btn-class{
              height: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .dft-goods_btn-class1{
              width: 18px;
              height: 18px;
              border-radius: 50%;
              border: 1px solid #f44;
              font-size: 16px;
            }
            .dft-goods_btn-class3{
              padding: 0 6px;
              border-radius: 10px;
              font-size: 11px;
              background: #f44;
              color: #fff;
            }
            .dft-goods_btn-class4{
              padding: 0 6px;
              font-size: 11px;
              border: 1px solid #f44;
              color: #f44;
            }
            .dft-goods_btn-class7{
              padding: 0 6px;
              font-size: 11px;
              background: #f44;
              color: #fff;
            }
            .dft-goods_btn-class8{
              padding: 0 6px;
              font-size: 11px;
              border: 1px solid #f44;
              color: #f44;
              border-radius: 10px;
            }
          }
        }
        .dft-bargain_press_area{
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: flex-end;
          flex: 1;
          .dft-bargain_price{
            flex: 1;
            width: 100%;
            position: relative;
            .dft-bargain_price_in{
              position: absolute;
              font-size: 12px;
              color: #ff3d12;
            }
            .dft-bargain_price_start{
              top: 6px;
              left: 2px;
            }
            .dft-bargain_price_rule{
              top: 50%;
              left: 50%;
              transform: translate(-50%,-50%);
            }
            .dft-bargain_price_end{
              bottom: 8px;
              right: 2px;
            }
          }
          .dft-bargain_press{
            width: 100%;
            height: 32px;
            border-radius: 4px;
            flex-shrink: 0;
            display: grid;
            grid-template-columns: 1.6fr 1fr;
            text-align: left;
            overflow: hidden;
            .dft-bargain_hotv{
              background: #ffe9e5;
              color: #ff3d12;
              position: relative;
              overflow: hidden;
              display: flex;
              align-items: center;
              height: 100%;
              padding: 0 8px;
              font-size: 14px;
              &::after{
                position: absolute;
                right: -15px;
                top: -15px;
                width: 30px;
                height: 80px;
                display: block;
                content: '';
                z-index: 3;
                background: #fc530f;
                transform: rotate(32deg);
              }
            }
            .dft-bargain_btn{
              background: #fc530f;
              color: #fff;
              font-size: 17px;
              display: flex;
              justify-content: flex-end;
              height: 100%;
              align-items: center;
              padding-right: 6px;
            }
          }
        }
      }
    }
  }
  .img_class{
    display: block;
    width: 100%;
    height: 100%;
  }
  .tabs_box{
    width: 100%;
    height: 36px;
    font-size: 16px;
    line-height: 36px;
    border-radius: 10px 10px 0 0;
    overflow: hidden;
    display: flex;
    align-items: center;
    text-align: center;
    box-sizing: border-box;
  }
  .group_tab{
    width: 100%;
    height: 100%;
    background: #f2f2f2;
    color: #6c6c6c;
    box-sizing: border-box;
  }
  .activeTab{
    background: #fff;
    color: #ff3d03;
  }
  .tabin{
    margin: 4px 0;
    display: flex;
    overflow-x: auto;
    width: 100%;
    height: 36px;
    box-sizing: border-box;
    &::-webkit-scrollbar{
      width: 0;
      height: 0;
    }
  }
  .ctag_item{
    display: inline-block;
    width: auto;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    color: #333;
    background: #f2f2f4;
    border-radius: 6px;
    margin: 6px 4px;
    padding: 0 8px;
    flex-shrink: 0;
    box-sizing: border-box;
  }
  .activeTag{
    background-color: red;
    color: #fff;
  }
  /* 渐变进度条 */
  /deep/.dft-progress .el-progress-bar__inner{
    background-color: unset;
    background-image: linear-gradient(to right, #f94d07 , #fda96a);
  }
  .unic{
    border-radius: 4px;
    .dft-groupinfo{
      width: calc(100% - 24px);
      height: auto;
      max-height: 60px;
      padding: 8px 20px;
      margin: 4px 12px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 5px;
      background: #fff3f0;
      .dft-groupinfo_top{
        text-align: center;
        display: flex;
        justify-content: center;
        font-size: 14px;
        .dft-groupinfo_top_s{
          color: #ff0404;
          padding: 0 4px;
        }
      }
      .dft-groupinfo_avatar{
        display: flex;
        align-items: center;
        .dft-groupinfo_avatar_item{
          margin-left: -6px;
        }
      }
    }
    .dft-groupBtn{
      width: calc(100% - 24px);
      height: 40px;
      padding: 8px 20px;
      margin: 4px 12px 12px;
      font-size: 14px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 6px;
      background: #fa5513;
      color: #fff;
    }
  }
  .label_box{
    height: 24px;
    line-height: 24px;
  }
  .tt {
      font-size: 9px;
      color: #909090;
      position: relative;
      margin-right: 8px;
      margin-top: 5px;
    flex-shrink: 0;
  }
  
  .tt::after {
      content: "|";
      position: absolute;
      right: -5px;
      /* 调整竖线的位置，可以根据需要调整 */
      top: 50%;
      transform: translateY(-50%);
  }
  
  .tt:last-child::after {
      content: "";
      /* 去掉最后一个元素的竖线 */
  }
  .item-desc {
      height: 16px;
      align-items: flex-end;
      margin-top: 3px;
      font-size: 10px;
      color: #97714C;
  }
  .active_dft-goods_info2{
    position: absolute;
    color: #969799;
    font-size: 10px;
    right: 6px;
    bottom: 2px;
  }
.img_class{
  position: absolute;
  top: 0;
  left: 0;
}
.dft-header_title1{
  font-size: 18px;
  font-weight: 600;
  position: relative;
  line-height: 32px;
  padding-left: 12px;
  color: #4A4A4A;
  transform: translateY(2px);
  z-index: 2;
}
.ctag_item{
  background: transparent;
}
.activeTag{
  background: transparent;
  color: #FA5714;
  font-weight: 500;
  position: relative;
  &::after{
    position: absolute;
    bottom: -2px;
    left: 50%;
    transform: translateX(-50%);
    content: '';
    width: 60%;
    height: 2px;
    border-radius: 2px;
    background: #FA5714;
    // z-index: -1;
  }
}
.dft-goods_name{
  font-weight: 500;
  font-size: 15px;
}
.dft-goods_info{
  font-size: 11px;
}
.tt{
  border: 1px solid #FA5714;
	padding: 0 2px;
	border-radius: 3px;
  margin: 0;
	color: #FA5714;
  &::after{
    display: none;
  }
}
.tt+.tt{
  margin-left: 4px;
}
</style>